<template>
    <div :class="cssClass">
        <div class="right-drawer">
            <div class="right-drawer-content">
                <div v-if="rightDrawerContent" class="drawer-body">
                    <component :is="viewComponent" :item="rightDrawerContent.item" v-if="viewComponent" />
                </div>
            </div>
        </div>
        <nav class="side-rail">
            <ul>
                <li :class="{ active: showingTaskQueue }">
                    <NavigationButton @click="showTaskQueue" icon="list_alt" v-if="hasTaskQueue" />
                </li>
                <li :class="{ active: showingNotes }">
                    <NavigationButton @click="showNotes" icon="note_alt" v-if="notesEnabled" />
                </li>
            </ul>
        </nav>
    </div>
</template>
<script>
import actions from '@/store/actions'
import { hasDataEntryRole } from '@/utils/jwt.js'

import ActivityDetailsSheet from '@/components/activity/ActivityDetailsSheet'
import { RightSheet as DataEntryNotes } from '@/components/manage/DataEntryNotes/'
import EntityTaskQueue from '@/components/manage/tasks/EntityTaskQueue.vue'
import NavigationButton from '@/components/shared/navigation-button.vue'
import StandaloneTaskItem from '@/components/manage/tasks/standalone-task-item.vue'

export default {
    name: 'RightRail',
    components: {
        NavigationButton,
        activity: ActivityDetailsSheet,
        'task-item': StandaloneTaskItem,
        'data-entry-notes': DataEntryNotes,
        'task-queue': EntityTaskQueue,
    },
    computed: {
        viewComponent() {
            let component = this.rightDrawerContent?.type || ''
            if (this.$options.components[component]) {
                return component
            }
            return null
        },
        showingTaskQueue() {
            return this.viewComponent === 'task-queue'
        },
        showingNotes() {
            return this.viewComponent === 'data-entry-notes'
        },
        rightDrawerContent() {
            return this.$store.getters.rightDrawerContent
        },
        showDrawer() {
            return this.railOpen && this.drawerOpen
        },
        showDrawerKnob() {
            return this.$store.getters.rightRailContent?.type
        },
        showRail() {
            return this.railOpen
        },
        cssClass() {
            return { 'right-rail': true, 'drawer-closed': !this.showDrawer }
        },
        drawerOpen: {
            get() {
                return this.$store.getters.rightDrawerOpen
            },
            set(value) {
                this.$store.dispatch(actions.setRightDrawerOpen, value)
            },
        },
        railOpen: {
            get() {
                return this.$store.getters.rightRailOpen
            },
            set(value) {
                this.$store.dispatch(actions.setRightRailOpen, value)
            },
        },
        hasTaskQueue() {
            return !!this.$store.getters.currentEntity && hasDataEntryRole()
        },
        notesEnabled() {
            return !!this.$store.getters.currentEntity && hasDataEntryRole()
        },
    },
    methods: {
        openRail() {
            this.railOpen = true
        },
        closeRail() {
            this.railOpen = false
        },
        openDrawer() {
            this.drawerOpen = true
        },
        closeDrawer() {
            this.drawerOpen = false
        },
        showNotes() {
            this.$store.dispatch(actions.showDataEntryNotes)
        },
        showTaskQueue() {
            this.$store.dispatch(actions.showTaskQueue)
        },
    },
}
</script>
<style>
.right-rail {
    height: calc(100vh - var(--top-rail-height));
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;

    & > * {
        transition: width 0.5s;
    }

    .side-rail {
        border-left: var(--side-rail-border);
        height: 100%;
        padding-top: 32px;

        li.active {
            --active-border-width: 4px;

            border-left: var(--active-border-width) solid var(--color-active);
            padding-left: calc((var(--active-border-width) - var(--side-rail-border-width)) / 2);
            position: relative;
            left: calc(-1 * var(--side-rail-border-width));
        }
    }

    .right-drawer {
        overflow-x: hidden;
        width: var(--right-drawer-width);
        .right-drawer-content {
            display: flex;
            flex-wrap: nowrap;
            flex-direction: column;
            justify-content: flex-start;
            align-items: stretch;
            height: 100%;
            min-width: var(--right-drawer-width);
            border-left: var(--side-rail-border);

            .drawer-body {
                height: 100%;
            }

            h2 {
                line-height: var(--spacing-3);
            }
        }
    }

    &.drawer-closed {
        .right-drawer {
            width: 0px;
        }
    }
}
</style>
